<div class="dialog-content-wrapper compact-dialog">
    <mat-toolbar matDialogTitle class="header accent-700 p-16">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <div class="contact-name mt-8">{{title}}</div>
            <button mat-icon-button *ngIf="!isLoading" (click)="dimiss()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-10  pb-0 m-0">
        <div fxLayout="column" fxLayoutGap="8px" class="table-scroll">
            <table mat-table [dataSource]="services.controls" class="mat-elevation-z1 compact-table"
                *ngIf="services?.length">
                <!-- Send Column -->
                <ng-container matColumnDef="send">
                    <th mat-header-cell *matHeaderCellDef> Enviar </th>
                    <td mat-cell *matCellDef="let row" [formGroup]="row">
                        <mat-checkbox [disabled]="row.get('orderCollectId')?.value != null"  formControlName="send" color="primary"></mat-checkbox>
                    </td>
                </ng-container>
                <!-- Procedure Code -->
                <ng-container matColumnDef="procedureCode">
                    <th mat-header-cell *matHeaderCellDef> Código </th>
                    <td mat-cell *matCellDef="let row" [formGroup]="row">
                        {{ row.get('procedureCodeDB')?.value || '-' }}
                    </td>
                </ng-container>

                <!-- Procedure Name -->
                <ng-container matColumnDef="procedureName">
                    <th mat-header-cell *matHeaderCellDef> Procedimento </th>
                    <td mat-cell *matCellDef="let row" [formGroup]="row">
                        {{ row.get('procedureNameDB')?.value || '-' }}
                        <div *ngIf="row.get('procedureCodeDB')?.value == null" class="mat-error"
                            style="margin-top: 2px; font-size: 12px;">
                            Exame não encontrado para envio
                        </div>
                    </td>
                </ng-container>

                <!-- Material Column -->
                <ng-container matColumnDef="material">
                    <th mat-header-cell *matHeaderCellDef> Material </th>
                    <td mat-cell *matCellDef="let row" [formGroup]="row">
                        {{ row.get('material')?.value || '-' }}
                    </td>
                </ng-container>

                <!-- Volume Column -->
                <ng-container matColumnDef="volume">
                    <th mat-header-cell *matHeaderCellDef> Volume coleta </th>
                    <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
                        <ng-container *ngIf="row.get('requiredVolume')?.value !== 0; else emptyCell">
                            <mat-form-field appearance="outline" floatLabel="auto" class="w-96 compact-field">
                                <input matInput type="string" min="0" formControlName="volume" placeholder="0" />
                            </mat-form-field>
                        </ng-container>
                        <ng-template #emptyCell>
                            <span>-</span>
                        </ng-template>
                    </td>
                </ng-container>
               
                <!-- Status Column -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef> Status </th>
                    <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
                        {{ row.get('status')?.value || 'Não enviado' }}
                    </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <div class="mat-caption" *ngIf="!services?.length">Nenhum serviço para exibir.</div>
        </div>
    </div>

    <mat-divider></mat-divider>

    <div mat-dialog-actions class="p-16" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px" style="margin: 5px;">
        <button mat-stroked-button color="primary" (click)="onSave()" [disabled]="form?.invalid || isLoading" style="margin: 5px;">
            <ng-container *ngIf="!isLoading">Enviar procedimentos</ng-container>
            <ng-container *ngIf="isLoading" >
                <span style="display: inline-flex; align-items: center;">
                    <mat-progress-spinner diameter="20" mode="indeterminate" color="primary"
                        style="margin-right: 8px; vertical-align: middle;"></mat-progress-spinner>
                    Carregando...
                </span>
            </ng-container>
        </button>
        <button *ngIf="!isLoading" mat-stroked-button (click)="checkStatus()">Atualizar Status</button>
        <button *ngIf="!isLoading" mat-stroked-button (click)="getResult()">Baixar resultado</button>
        <button *ngIf="!isLoading" mat-stroked-button (click)="dimiss()">Fechar</button>
    </div>
</div>